module.exports = __webpack_public_path__ + "static/img/04easy.e304a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/09startTrain/04easy.png
// module id = 1+Ao
// module chunks = 0